@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: relative;

  @include for-phone-only {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
  }

  &.hasFixedFooter {
    @include for-phone-only {
      position: relative;
    }
  }

  &.centerContent .titleAndDescription {
    align-items: center;
    text-align: center;
  }
}

.scrollContainer {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 5px 25px 0 25px;

  [data-ff-experiment-onboarding-strategies] & {
    padding: 20px;
  }

  @include for-desktop-only {
    padding: 0;
  }

  @include for-phone-only {
    padding: 15px;
    flex: 1;
    gap: 25px;
  }

  @media (max-width: $phoneSmlMaxWidth) {
    padding: 5px 15px 15px 15px;
  }
}

.header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.content {
  display: flex;
  flex-direction: column;
  flex: 1;

  @include for-desktop-only {
    margin-bottom: 60px;
  }

  @include for-phone-only {
    margin: 0;

    [data-ff-experiment-onboarding-strategies] & {
      height: calc(100% - 84px);
      margin-bottom: 84px;
    }
  }
}

// Desktop footer observer element - invisible but used for intersection detection
.desktopFooterObserver {
  height: 10px;
  width: 100%;
  flex-shrink: 0;
  visibility: hidden;

  @include for-phone-only {
    display: none;
  }
}

/* Desktop footer fix */
.desktopFooter {
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  padding: 20px 25px;
  transition: padding 0.3s ease, background 0.3s ease, box-shadow 0.3s ease, border-radius 0.3s ease;
  z-index: 10;

  &.stickyDesktopFooter {
    position: fixed;
    bottom: 20px;
    width: calc(100% - 50px);
    max-width: calc(100% - 50px);

    left: 50%;
    transform: translateX(-50%);

    max-width: 725px;

    border-radius: 15px;
    background: var(--light-80);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.02), 1px 1px 0px 0px #fff inset, 0px 8px 27px 0px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(25px);
    padding: 16px 25px;
  }

  &.centeredFooter {
    justify-content: center;
  }
}
// Mobile fixed footer
.mobileFooter {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: transparent;
  z-index: 10;
  transition: box-shadow 0.3s ease;

  &.withShadow {
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  }
}

.mobileFooterContent {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  background: white;
  border-radius: 10px;
  margin: 0 15px 15px 15px;

  &:has(.skipAndNext:only-child) {
    justify-content: flex-end;
  }

  &:has(button:only-child) {
    padding: 0;
  }
}

// Add space at the bottom when we have a fixed footer to prevent content from being hidden
.footerSpacer {
  height: 150px;
  flex-shrink: 0;

  @include for-desktop-only {
    display: none;
  }
}

.title {
  color: #000;
  font-family: Sohne;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.4px;

  @include for-phone-only {
    font-size: 30px;
  }
}

.titleAndDescription {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 30px;
  width: 100%;

  @include for-phone-only {
    margin-bottom: 0;
    gap: 8px;
  }

  @include for-desktop-only {
    gap: 8px;
    margin-bottom: 40px;
  }
}

.skipAndNext {
  display: flex;
  gap: 10px;
}
